export enum EcomPlatformWidgetID {
  CART_ICON = '1380bbc4-1485-9d44-4616-92e36b1ead6b',
  CART = '1380bbab-4da3-36b0-efb4-2e0599971d14',
  SIDE_CART = '49dbb2d9-d9e5-4605-a147-e926605bf164',
  ECOM_PLATFORM_CHECKOUT = '14fd5970-8072-c276-1246-058b79e70c1a',
  MY_ADDRESSES = '151290e1-62a2-0775-6fbc-02182fad5dec',
  PAYMENT_REQUEST = '4425f8e8-51fb-457b-9123-fdb7b1cef94a',
  THANK_YOU_PAGE = '1380bbb4-8df0-fd38-a235-88821cf3f8a4',
  ADD_TO_CART = '14666402-0bc7-b763-e875-e99840d131bd',
  GALLERY_PAGE = '1380bba0-253e-a800-a235-88821cf3f8a4',
}

export const ECOM_PLATFORM_APP_DEF_ID = '1380b703-ce81-ff05-f115-39571d94dfcd';

export const VIEWER_SCRIPT_DSN =
  'https://8bc29fb6cd064a49a9945743de020bf2@sentry.io/1186457';

export const MINICART_POPUP_URL =
  'https://ecom.wixapps.net/storefront/cartwidgetPopup';

export const DEDAULT_TINY_CART_CONFIG = {
  theme: 'BARE',
  width: '0%',
  height: '100%',
  position: {
    origin: 'FIXED',
    placement: 'TOP_RIGHT',
    x: 0,
    y: 0,
  },
};

const ONE_MINUTE = 60 * 1000;
export const CACHE_TTL_MS = 10 * ONE_MINUTE;
export const DEFAULT_CURRENCY_HEADER = 'DEFAULT';
export const DEADLINE_HEADER_NAME = 'X-Time-Budget';
export const INSTANCE_PARAM = 'instanceOverride';

export const SecondaryEvents = {
  GetRequest: 'CurrentCart.GetRequest',
  GetGQLRequest: 'CurrentCart.GetGQLRequest',
  GetV1Request: 'CurrentCart.GetV1Request',
  GetCurrentCartIdFromCacheRequest:
    'CurrentCart.GetCurrentCartIdFromCacheRequest',
  RefreshV1Request: 'CurrentCart.RefreshV1Request',
  UpdateLineItemsInCurrentCartRequest:
    'CurrentCart.UpdateLineItemsInCurrentCartRequest',
  RemoveLineItemsFromCurrentCartRequest:
    'CurrentCart.RemoveLineItemsFromCurrentCartRequest',
  OnLoginStartRequest: 'CurrentCart.OnLoginStartRequest',
  OnLoginFinishRequest: 'CurrentCart.OnLoginFinishRequest',
  AddCouponToCurrentCartRequest: 'CurrentCart.AddCouponToCurrentCartRequest',
  RemoveCouponFromCurrentCartRequest:
    'CurrentCart.RemoveCouponFromCurrentCartRequest',
  SetDeliveryMethodForCurrentCartRequest:
    'CurrentCart.SetDeliveryMethodForCurrentCartRequest',
  RemoveDeliveryMethodFromCurrentCartRequest:
    'CurrentCart.RemoveDeliveryMethodFromCurrentCartRequest',
  AddLineItemsToCurrentCart: 'CurrentCart.AddLineItemsToCurrentCart',
  UpdateCurrentCartRequest: 'CurrentCart.UpdateCurrentCartRequest',
  RefreshCurrentCartRequest: 'CurrentCart.RefreshCurrentCartRequest',
  ActionResponse: 'CurrentCart.ActionResponse',
  CalculateCurrentCart: 'CurrentCart.CalculateCurrentCart',
  EstimateCurrentCart: 'CurrentCart.EstimateCurrentCart',
  GetUpsellOptionsForCurrentCart: 'CurrentCart.GetUpsellOptionsForCurrentCart',
  RemoveGiftCardFromCurrentCartRequest:
    'CurrentCart.RemoveGiftCardFromCurrentCartRequest',
  AddGiftCardToCurrentCartRequest:
    'CurrentCart.AddGiftCardToCurrentCartRequest',
  UpdateFormSubmissionsInCurrentCartRequest:
    'CurrentCart.UpdateFormSubmissionsInCurrentCartRequest',
  Updated: 'CurrentCart.Updated',
  HEALTH_CHECK: 'CurrentCart.HEALTH_CHECK',
  ACK: 'CurrentCart.ACK',
};

export const MiniCartEvents = {
  LoadedWithoutData: 'Minicart.LoadedWithoutData',
  OnInitialData: 'Minicart.OnInitialData',
};

/** @deprecated */
export const petriSpecs = {
  MigrateCreateViewerScriptCodeFromSdk:
    'specs.ecom.MigrateCreateViewerScriptCodeFromSdk',
  AlwaysSendCurrencyHeader: 'specs.ecom.AlwaysSendCurrencyHeader',
  OpenSuccessPopup: 'specs.ecom.OpenSuccessPopup',
  SupportMultipleGCInCheckout: 'specs.ecom.SupportMultipleGCInCheckout',
};

export const conductorSpecs = {
  ecomCartValidationsInPurchaseFlow: 'ecomCartValidationsInPurchaseFlow',
  ecomFallbackForMissingEcommerceSettings:
    'ecomFallbackForMissingEcommerceSettings',
  ecomSyncSelectedPaymentMethodToCart: 'ecomSyncSelectedPaymentMethodToCart',
};

export const SPECS = {
  ...petriSpecs,
  ...conductorSpecs,
};
